// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withLogger } from 'gandi.redux-logger';

import type { FullState } from 'src/types';

import { getInitialValues } from '../helpers';

import Presenter from './Presenter';
import type { StateProps, OwnProps } from './Presenter';

const mapStateToProps = (
  state: FullState,
  { canWriteContactBook }: OwnProps,
): StateProps => {
  return {
    initialValues: getInitialValues(canWriteContactBook),
  };
};

const Create: React.ComponentType<OwnProps> = compose(
  connect(mapStateToProps),
  withLogger('Batch/RoleContact/Create'),
)(Presenter);

Create.displayName = 'Create';

export default Create;
